<script setup lang="ts">
/**
 * @author Giorgi Tseradze
 */

//
import { onMounted, ref, Ref } from "vue";
import AboutCard from "@/components/smartComponents/AboutUs/parts/AboutCard.vue";
import type { SecondaryDataInterface } from "@/types/ContentType";
const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

const props = defineProps<{
  contentData: SecondaryDataInterface | undefined;
}>();

const newArr: Ref = ref([]);

/** Separate numeric, nonnumeric data and title */
const handleData = () => {
  newArr.value = props?.contentData?.data?.list?.[0]?.tooltip?.map((item) => {
    let newVal = null;
    const numericPart = parseInt(item?.tipText);
    const nonNumericPart = item?.tipText?.substring(numericPart.toString().length);
    newVal = {
      num: numericPart,
      nonNum: nonNumericPart,
      teaser: item?.tipHover,
    };
    
    return newVal;
  });
};

onMounted(() => {
  handleData();
});
</script>

<template>
  <div class="about d-flex dir-col pos-rel">
    <h1 class="hl-1 uppercase">{{ contentData?.data?.list?.[0]?.title }}</h1>
    <div class="hl-4 about__editor" v-html="contentData?.data?.list?.[0]?.content"></div>
    <div class="pos-abs about__image" v-if="newArr?.length">
      <div class="pos-rel about__image-card">
        <Picture
          :devices="contentData?.data?.list?.[0]?.image?.[0]?.devices"
          class="img-absolute"
          :alt="contentData?.data?.list?.[0]?.title"
        />
      </div>
    </div>
    <div class="about__inner">
      <div class="about__inner-row">
        <AboutCard v-for="(item, index) in newArr" :key="index" :content="item" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="./styles/about.scss" />
